import React from 'react';
import './CTASection.css';
import PixelCard from '../PixelCard';

const CTASection = () => {
  return (
    <section className="cta-section">
      <div className="cta-container">
        <PixelCard variant="pink" className="cta-pixel-card">
          <div className="cta-content">
            <div className="cta-text">
                <div className="cta-badge">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M8 1L10.5 5.5L15 6L11.5 9.5L12.5 14L8 12L3.5 14L4.5 9.5L1 6L5.5 5.5L8 1Z" fill="#00ff88"/>
                </svg>
                БЕСПЛАТНЫЙ ПРОБНЫЙ ПЕРИОД
                </div>
                
                <h2 className="cta-title">
                Попробуйте RED BUTTON
                <span className="highlight"> бесплатно 7 дней</span>
                </h2>
                
                <p className="cta-description">
                Полный доступ ко всем возможностям • Без привязки карты • 
                Отмена в любое время • Начните прямо сейчас
                </p>
                
                <div className="cta-features">
                <div className="feature-item">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M16.5 6L7.5 15L3.5 11" stroke="#00ff88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>Все сервера</span>
                </div>
                <div className="feature-item">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M16.5 6L7.5 15L3.5 11" stroke="#00ff88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>Максимальная скорость соединения</span>
                </div>
                <div className="feature-item">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M16.5 6L7.5 15L3.5 11" stroke="#00ff88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span>10Gb трафика</span>
                </div>
                </div>
                
                <a href='https://t.me/redbutton_vpn_bot' target='_blank'><button className="cta-button">
                <span className="button-text">Начать бесплатно</span>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M4 10h12M12 4l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                </button></a>
                
                <div className="cta-guarantee">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M8 0.5L2 3v4.5C2 11.85 4.69 15.31 8 16C11.31 15.31 14 11.85 14 7.5V3L8 0.5Z" stroke="#00ff88" strokeWidth="1.5"/>
                    <path d="M6 8L7.5 9.5L10 6.5" stroke="#00ff88" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                Без автоплатежей • Отмена одним кликом
                </div>
            </div>
            </div>
        </PixelCard>
      </div>
    </section>
  );
};

export default CTASection;